import { getConsent } from '@/lib/consent';

// Minimal analytics bridge: pushes GA4-style events to window.dataLayer when a
// tag manager is present AND the visitor allowed analytics cookies. Only
// product ids are sent — never product names.
export const track = (event, params = {}) => {
  try {
    if (typeof window === 'undefined' || !Array.isArray(window.dataLayer)) return;
    if (!getConsent()?.analytics) return;
    window.dataLayer.push({ event, ...params });
  } catch {
    // analytics must never break the shop
  }
};
